import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react'
import Chip from '@mui/material/Chip'
import { formatMinutes, type MaintenanceZone } from '@jupi/shared'

// Colour is never the only signal: each zone also has its own icon and words,
// for a mechanic in glare, in a hangar's yellow light, or colour blind.
const ZONE = {
  green: { color: 'success', icon: 'mdi:check-circle' },
  amber: { color: 'warning', icon: 'mdi:alert' },
  red: { color: 'error', icon: 'mdi:alert-octagon' },
  over: { color: 'error', icon: 'mdi:close-octagon' },
} as const

export const ZONE_COLOUR: Record<MaintenanceZone, string> = {
  green: 'success.main',
  amber: 'warning.main',
  red: 'error.main',
  over: 'error.main',
}

// "40:00 h left", or "4:00 h overdue" past the due point.
export function ZoneBadge({ zone, minutesToDue }: { zone: MaintenanceZone; minutesToDue: number }) {
  const { t } = useTranslation()
  const { color, icon } = ZONE[zone]
  const label =
    minutesToDue >= 0
      ? t('huolto.hoursLeft', { time: formatMinutes(minutesToDue) })
      : t('huolto.hoursOver', { time: formatMinutes(-minutesToDue) })
  return <Chip color={color} icon={<Icon icon={icon} width={22} />} label={label} />
}
